import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

export const Wrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  marginBottom: '77px',
  '@media (max-width: 750px)': {
    marginBottom: '56px'
  }
}));

export const ContentWrapper = styled(Box)(({ theme, m }) => ({
  margin:  m ? m : '42px 0 0 0 ',
  '@media (max-width: 750px)': {
    margin: '18px'
  }
}));


export const TitleWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  width: '100%',
  marginBottom: '24px',
  '@media (max-width: 750px)': {
    flexDirection: 'column',
  },
}));




export const CareersText = styled(Typography)(({ theme }) => ({
  fontStyle: 'normal',
  color: '#FFFFFF',
  '&.MuiTypography-h1': {
    fontFamily: 'Open Sans SemiBold',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '30px',
    marginTop: '56px',
    marginBottom: '24px',
    textAlign: 'center',
  },

  '&.MuiTypography-titleWhite': {
    fontFamily: 'Open Sans Bold',
    fontWeight: 700,
    fontSize: '40px',
    lineHeight: '54px',
    color: '#FFFFFF',
  },

  '&.MuiTypography-titleYellow': {
    fontFamily: 'Open Sans Bold',
    fontWeight: 700,
    fontSize: '40px',
    lineHeight: '54px',
    color: '#F4CD00',
  },

  '&.MuiTypography-p': {
    fontFamily: 'Open Sans Regular',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '30px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },

  '&.MuiTypography-subTitleYellow': {
    fontFamily: 'Open Sans SemiBold',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '30px',
    color: '#F4CD00',

  },

  '&.MuiTypography-jobTitle': {
    fontFamily: 'Open Sans Bold',
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '30px',
    color: '#FFFFFF',
  },




  /// Mobile
  '@media (max-width: 750px)': {
    '&.MuiTypography-h1': {
      fontFamily: 'Open Sans SemiBold',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '30px',
      marginTop: '56px',
      textAlign: 'center',
    },

    '&.MuiTypography-titleWhite, &.MuiTypography-titleYellow': {
      fontSize: '28px',
      lineHeight: '38px',
    },

    '&.MuiTypography-jobTitle': {
      fontSize: '24px',
      lineHeight: '32px',
    },
  }
}));




export const PathCardsWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '24px',
  marginTop: '24px',
  '@media (max-width: 750px)': {
    flexDirection: 'column',
    gap: '16px',
  },
}));

export const PathCard = styled(Box)(() => ({
  flex: 1,
  backgroundColor: '#FFFFFF',
  borderRadius: '16px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  '@media (max-width: 750px)': {
    padding: '24px',
  },
}));

export const Pill = styled(Box)(() => ({
  alignSelf: 'flex-start',
  border: '1px solid #183561',
  borderRadius: '999px',
  padding: '4px 14px',
  fontFamily: 'Open Sans SemiBold',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#183561',
  backgroundColor: '#EFF6FF',
}));

export const TagsWrapper = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  marginTop: '8px',
}));

export const Tag = styled(Box)(() => ({
  border: '1px solid #D1D1D6',
  borderRadius: '999px',
  padding: '6px 14px',
  fontFamily: 'Inter Regular',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#212121',
}));


/* ------------------------------ Trainer accordion sections ------------------------------ */

export const SectionsWrapper = styled(Box)(() => ({
  width: '100%',
  marginTop: '64px',
  '@media (max-width: 750px)': {
    marginTop: '40px',
  },
}));

export const DashedDivider = styled(Box)(() => ({
  borderTop: '2px dashed rgba(255, 255, 255, 0.4)',
  margin: '48px 0',
  '@media (max-width: 750px)': {
    margin: '32px 0',
  },
}));

export const SectionTagline = styled(Box)(() => ({
  fontFamily: 'Open Sans SemiBold',
  fontWeight: 600,
  fontSize: '20px',
  lineHeight: '30px',
  color: '#F4CD00',
  marginTop: '4px',
  '@media (max-width: 750px)': {
    fontSize: '16px',
    lineHeight: '24px',
  },
}));

export const SectionIntro = styled(Box)(() => ({
  fontFamily: 'Open Sans Regular',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '30px',
  color: '#FFFFFF',
  margin: '16px 0 32px 0',
  '@media (max-width: 750px)': {
    fontSize: '14px',
    lineHeight: '24px',
    margin: '12px 0 24px 0',
  },
}));

export const BenefitsGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '24px',
  '@media (max-width: 750px)': {
    gridTemplateColumns: '1fr',
    gap: '16px',
  },
}));

export const BenefitCard = styled(Box)(({ wide }) => ({
  gridColumn: wide ? '1 / -1' : 'auto',
  backgroundColor: '#FFFFFF',
  borderRadius: '16px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '20px',
  '@media (max-width: 750px)': {
    gap: '16px',
  },
}));

export const BenefitContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

export const BenefitIconImg = styled('img')(() => ({
  width: '56px',
  height: '56px',
  minWidth: '56px',
  display: 'block',
}));

export const BenefitIcon = styled(Box)(() => ({
  width: '56px',
  height: '56px',
  minWidth: '56px',
  borderRadius: '999px',
  backgroundColor: '#F4CD00',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    color: '#183561',
    width: '28px',
    height: '28px',
  },
}));

export const BenefitTitle = styled(Box)(() => ({
  fontFamily: 'Open Sans Bold',
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: '28px',
  color: '#183561',
  '@media (max-width: 750px)': {
    fontSize: '18px',
    lineHeight: '26px',
  },
}));

export const BenefitText = styled(Box)(() => ({
  fontFamily: 'Open Sans Regular',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '26px',
  color: '#183561',
}));

export const ApplyBox = styled(Box)(() => ({
  backgroundColor: '#EDF3FB',
  borderRadius: '16px',
  padding: '24px',
  marginTop: '24px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '24px',
  '@media (max-width: 750px)': {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '24px',
  },
}));

export const ApplyTextGroup = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

export const ApplyTitle = styled(Box)(() => ({
  fontFamily: 'Open Sans Bold',
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '32px',
  color: '#183561',
}));

export const ApplyText = styled(Box)(() => ({
  fontFamily: 'Open Sans Regular',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '30px',
  color: '#183561',
  '@media (max-width: 750px)': {
    fontSize: '14px',
    lineHeight: '24px',
  },
}));

export const ApplyButton = styled('a')(() => ({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  textDecoration: 'none',
  backgroundColor: '#183561',
  color: '#FFFFFF',
  borderRadius: '12px',
  padding: '14px 24px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '10px',
  fontFamily: 'Open Sans SemiBold',
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '24px',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: '#0f2647',
  },
  '& svg': {
    width: '22px',
    height: '22px',
  },
}));


/* ------------------------------ DSA Needs Assessors ------------------------------ */

export const InfoCard = styled(Box)(() => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '16px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  '@media (max-width: 750px)': {
    padding: '24px',
  },
}));

export const InfoHeading = styled(Box)(() => ({
  fontFamily: 'Open Sans Bold',
  fontWeight: 700,
  fontSize: '28px',
  lineHeight: '36px',
  color: '#183561',
  '@media (max-width: 750px)': {
    fontSize: '22px',
    lineHeight: '30px',
  },
}));

export const InfoText = styled(Box)(() => ({
  fontFamily: 'Open Sans Regular',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '30px',
  color: '#475467',
  '@media (max-width: 750px)': {
    fontSize: '14px',
    lineHeight: '24px',
  },
}));


/* ------------------------------ Disability Confident banner ------------------------------ */

export const Banner = styled(Box)(() => ({
  backgroundColor: '#F4CD00',
  borderRadius: '24px',
  padding: '24px',
  marginTop: '64px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  '@media (max-width: 750px)': {
    padding: '24px',
    marginTop: '40px',
  },
}));

export const BannerTitle = styled(Box)(() => ({
  fontFamily: 'Open Sans Bold',
  fontWeight: 700,
  fontSize: '32px',
  lineHeight: '40px',
  color: '#183561',
  '@media (max-width: 750px)': {
    fontSize: '24px',
    lineHeight: '32px',
  },
}));

export const BannerText = styled(Box)(() => ({
  fontFamily: 'Open Sans Regular',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '30px',
  color: '#183561',
  '@media (max-width: 750px)': {
    fontSize: '14px',
    lineHeight: '24px',
  },
}));
